// /var/www/afra/web-design.rampagesoft.com/my-app/src/metatag/MetaTagContentDetail.js

import React from 'react';
import { Helmet } from 'react-helmet';

// Utility function to strip HTML tags (copied from ContentDetail.js)
const stripHtml = (html) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
};

const MetaTagContentDetail = ({ content, currentUrl, imageUrl }) => {
  // Prepare Structured Data (Schema.org Article)
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": content?.Home_Sub || "Content Detail",
    "description": stripHtml(content?.Home_Short || '').substring(0, 160),
    "datePublished": content?.Home_Date || '',
    "image": imageUrl || 'https://afaa.website/s/ff6970.png',
    "url": currentUrl,
    "author": {
      "@type": "Organization",
      "name": "AFRA APACHE"
    },
    "publisher": {
      "@type": "Organization",
      "name": "AFRA APACHE",
      "logo": {
        "@type": "ImageObject",
        "url": "https://afaa.website/s/ff6970.png"
      }
    }
  };

  return (
    <Helmet>
      <title>{content?.Home_Sub || 'Content Detail'}</title>
      <meta name="description" content={stripHtml(content?.Home_Short || '').substring(0, 160)} />

      {/* Sitemap Schema (moved from ContentDetail.js) */}
      <script type="application/xml">
        {`
          <?xml version="1.0" encoding="UTF-8"?>
          <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
            <url>
              <loc>${currentUrl}</loc>
              <lastmod>${content?.Home_Date || ''}</lastmod>
              <changefreq>weekly</changefreq>
              <priority>0.8</priority>
            </url>
          </urlset>
        `}
      </script>

      {/* Structured Data (Schema.org Article) */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>

      {/* Additional Meta Tags (inspired by meta-tag.js) */}
      <link rel="icon" type="image/png" href="https://afaa.website/s/ff6970.png" />
      <meta http-equiv="revisit-after" content="3 days" />
      <meta http-equiv="Cache-control" content="public" />
      <meta name="copyright" content="AFRA APACHE" />
      <meta name="owner" content="AFRA APACHE" />
      <meta name="web_author" content="AFRA APACHE" />
      <meta name="author" content="AFRA APACHE" />
      <meta name="generator" content="react" />
      <meta name="distribution" content="Global" />
      <meta name="rating" content="General" />
      <meta name="expires" content="Never" />
      <link rel="canonical" href={currentUrl} />
      <meta property="og:title" content={content?.Home_Sub || 'Content Detail'} />
      <meta property="og:description" content={stripHtml(content?.Home_Short || '').substring(0, 160)} />
      <meta property="og:type" content="article" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:image" content={imageUrl || 'https://afaa.website/s/ff6970.png'} />
      <meta property="og:site_name" content="web-design.rampagesoft.com" />
      <meta property="og:locale" content="th_TH" />
      <meta property="og:image:secure_url" content={imageUrl || 'https://afaa.website/s/ff6970.png'} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@AFRAAPACHE" />
      <meta name="twitter:domain" content={currentUrl} />
      <meta name="twitter:title" content={content?.Home_Sub || 'Content Detail'} />
      <meta name="twitter:description" content={stripHtml(content?.Home_Short || '').substring(0, 160)} />
      <meta name="twitter:image" content={imageUrl || 'https://afaa.website/s/ff6970.png'} />
    </Helmet>
  );
};

export default MetaTagContentDetail;